import React from 'react'
import YouTube from 'react-youtube'
import getYouTubeId from 'get-youtube-id'

import styled from 'styled-components'

/* 
    Component for YouTube responsive view
    Shows YT movie only if it is possible to retrieve valid id for given YT url

    Handles:
    - no url passed (console warn) and not showint YT
    - non valid url with console.error and not showing YT at all

    Responsive styling with technique from
    https://github.com/tjallingt/react-youtube/issues/242
*/

const YouTubeView = ({ url }) => {
  if (!url) {
    console.warn(`Kino Grazyna - No url passed to the YouTubeView component`)
    return true
  }

  const movieId = getYouTubeId(url)
  if (!movieId) {
    console.error(`Kino Grazyna - No valid YouTube movie id for url ${url}`)
  }

  return (
    movieId && (
      <YTWrapper>
        <StyledYouTube videoId={movieId} />
      </YTWrapper>
    )
  )
}

const YTWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  overflow: hidden;
  margin-bottom: 50px;
`

const StyledYouTube = styled(YouTube)`
  /* style for iframe from react-youtube*/
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`

export default YouTubeView
